<template>
  <div class="modal deposit-modal">
    <div class="overlay" @click="closeDepositModal" />
    <div class="wrapper">
      <button class="close" @click="closeDepositModal">
        <img src="@/assets/img/closeNew.svg" alt="close new" srcset="" />
      </button>
      <div class="modal-content">
        <div class="container">
          <div class="form">
            <div class="form-wrapper">
              <div class="modal-main">
                <div class="form-fields register-content">
                  <div class="form-fields-wrapper">
                    <div class="title text-white">{{ $t("Deposit") }}</div>

                    <label>
                      <input
                        v-model="name"
                        type="text"
                        :placeholder="$t('First name')"
                      />
                    </label>
                    <label>
                      <input
                        v-model="surname"
                        type="text"
                        :placeholder="$t('Last Name')"
                      />
                    </label>
                    <label>
                      <input
                        v-model="email"
                        type="email"
                        :placeholder="$t('Email')"
                      />
                    </label>
                    <label>
                      <MazPhoneNumberInput
                        :autoFormat="false"
                        v-model="phone"
                        v-model:country-code="countryCode"
                        @update:countryCode="countryCode = $event"
                        :placeholder="$t('Phone number')"
                        show-code-on-list
                        :only-countries="countryOptionsIso"
                        country-locale="en-EN"
                        @update="phoneDataUpdate($event)"
                      />
                    </label>
                    <label class="country-select-container">
                      <div class="select-wrapper">
                        <select
                          v-model="countryId"
                          :class="{ empty: !countryId }"
                        >
                          <option value="" selected>
                            {{ $t("Country") }}
                          </option>
                          <option
                            v-for="option in countryOptions"
                            :key="option.id"
                            :value="option.id"
                          >
                            {{ option.title }}
                          </option>
                        </select>
                      </div>
                    </label>
                    <label>
                      <input
                        type="text"
                        :placeholder="$t('City')"
                        v-model="city"
                      />
                    </label>
                    <label>
                      <input
                        type="text"
                        :placeholder="$t('Address')"
                        v-model="address"
                      />
                    </label>
                    <label>
                      <input
                        type="text"
                        :placeholder="$t('Post Code')"
                        v-model="zip"
                      />
                    </label>

                    <label class="checkbox-label">
                      <div class="checkbox-label-wrapper">
                        <input type="checkbox" v-model="saveData" />
                        <div class="checkbox"></div>
                        <span class="title">{{
                          $t("save my data for faster checkout next time")
                        }}</span>
                      </div>
                    </label>

                    <label>
                      <input
                        class="amount"
                        type="text"
                        disabled
                        :value="depositAmount + ' ' + depositCurrency"
                      />
                    </label>
                    <div class="cta-container">
                      <button
                        class="button yellow small"
                        :loading="loaderIsVisible"
                        :disabled="!requiredFieldsAreFilled"
                        @click="submitDeposit"
                      >
                        {{ $t("Deposit") }}
                      </button>
                    </div>
                    <Transition>
                      <div v-if="error" class="error-desc desc red">
                        {{ error }}
                      </div>
                    </Transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container-bottom">
            <div class="cta-container">
              <span class="desc">
                {{ $t("By depositing you agree to our") + " " }}
              </span>
              <router-link
                v-if="termsPage"
                :to="`/pages/${termsPage.id}`"
                class="desc"
                target="_blank"
              >
                {{ termsPage.title }}
              </router-link>
              <template v-if="termsPage && privacyPage">
                <span class="desc"> {{ " " + $t("and") + " " }} </span>
                <router-link
                  :to="`/pages/${privacyPage.id}`"
                  class="desc"
                  target="_blank"
                >
                  {{ privacyPage.title }}
                </router-link>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { TERMS_PAGE, PRIVACY_PAGE } from "@/store/modules/staticPages";

export default {
  name: "DepositModal",
  components: {},
  props: {
    user: Object,
    loaderIsVisible: {
      type: Boolean,
      required: true,
    },
    depositAmount: {
      type: Number,
      required: true,
    },
    depositCurrency: {
      type: String,
      default: "€",
    },
    paymentType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      name: "",
      surname: "",
      email: "",
      phone: "",
      countryCode: "",
      phoneFull: "",
      countryOptions: [],
      countryOptionsIso: [],
      address: "",
      city: "",
      zip: "",
      countryId: "",
      error: "",
      saveData: false,
    };
  },
  computed: {
    ...mapGetters("user", ["userData"]),
    ...mapGetters("app", ["currencySymbol", "currencyCode"]),
    ...mapGetters("staticPages", ["getTermsPage", "getPrivacyPage"]),
    termsPage() {
      return this.getTermsPage;
    },
    privacyPage() {
      return this.getPrivacyPage;
    },
    requiredFieldsAreFilled() {
      return (
        this.name &&
        this.surname &&
        this.phone &&
        this.email &&
        this.countryId &&
        this.city &&
        this.address &&
        this.zip
      );
    },
  },
  created() {
    this.TERMS_PAGE = TERMS_PAGE;
    this.PRIVACY_PAGE = PRIVACY_PAGE;
  },
  mounted() {
    this.getCountries();
    this.initializeUserData();
  },
  methods: {
    ...mapActions("modals", ["closeDepositModal"]),
    ...mapActions("user", ["fetchUserData"]),
    initializeUserData() {
      console.log(this.userData);

      if (this.userData) {
        this.email = this.userData.email;
        this.name = this.userData.name;
        this.surname = this.userData.surname;
        this.phone = this.userData.phone;
        // this.countryCode = this.userData.country;
        this.address = this.userData.address;
        this.city = this.userData.city;
        this.zip = this.userData.zip;
        this.countryId = this.userData.country;
      }
    },
    phoneDataUpdate(e) {
      this.phoneFull = e.phoneNumber;
    },
    async getCountries() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API}countries`,
        );
        this.countryOptions = response.data.payload;
        this.countryOptionsIso = response.data.payload.map((obj) => obj.iso);
        this.countryCode = this.countryOptionsIso[0];
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    },
    async submitDeposit() {
      if (!this.requiredFieldsAreFilled) return;

      const depositData = {
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phoneFull,
        country: this.countryId,
        city: this.city,
        address: this.address,
        postCode: this.zip,
        amount: this.depositAmount,
        paymentType: this.paymentType,
        currency: this.currencyCode,
        saveData: this.saveData,
      };

      try {
        const response = await this.$http.post(
          `${process.env.VUE_APP_API}deposit/checkout`,
          depositData,
        );
        this.closeDepositModal();
        this.fetchUserData();

        if (response.data.status === "ERROR") {
          this.$toast.error(this.$t(response.data.message));
          this.$router.push({ name: "PaymentFailPage" });
        } else {
          window.location = response.data.redirect_url;
        }
      } catch (error) {
        console.log(error);
        this.$toast.error(this.$t(error.response.data.message));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container-wrapper {
  border: 1px solid #191919;
  padding: 12px;
  position: relative;
  max-width: 441.6px;
  width: 100%;
}

.modal .container {
  padding: 0;
  flex-direction: column;
}

.form {
  padding: 42px;
}

.container-bottom {
  padding: 0 19px 32px;
  margin: 0 auto;
}

.form-fields-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.title.small {
  font-size: 24px;
  font-weight: bold;
}

.country-select-container .select-wrapper {
  height: 46px;
}

.modal .form-fields label {
  margin-top: 0;
}

label {
  display: block;
}

.cta-container {
  margin-top: 20px;

  .button {
    width: 100%;
  }
}

.error-desc {
  color: #ff4444;
  margin-top: 10px;
}

.desc {
  font-size: 14px;
  color: #888;
}

a.desc {
  color: #15ca5c;
  text-decoration: none;
  cursor: pointer;
}

a.desc:hover {
  text-decoration: underline;
}

.amount {
  text-align: center;
  font-size: 32px;
}

@media (max-width: 768px) {
  .form {
    padding: 16px;
  }
}
</style>
